'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);

var SpotContainer = styled__default.div.withConfig({
  displayName: "spotstyle__SpotContainer",
  componentId: "sc-ph90qe-0"
})(["position:relative;width:", "px;height:", "px;line-height:0;"], function (props) {
  return props['data-size'];
}, function (props) {
  return props['data-size'];
});
var FavIconContainer = styled__default.div.withConfig({
  displayName: "spotstyle__FavIconContainer",
  componentId: "sc-ph90qe-1"
})(["position:absolute;z-index:10;right:-10%;bottom:-10%;width:", "px;height:", "px;"], function (props) {
  return props['data-size'];
}, function (props) {
  return props['data-size'];
});

exports.FavIconContainer = FavIconContainer;
exports.SpotContainer = SpotContainer;
